import React  from 'react';
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useState, useEffect } from 'react';
import Loader from 'react-loaders';
import Project from '../Project';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Projects = ({projects}) => {
  const [letterClass, setLetterClass] = useState('text-animate');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLetterClass('text-animate-hover')
     }, 3000);
    return () => clearTimeout(timeout);
   },[]);

  return (
  
    <>
      <div className='projectsContainers project-page'>
        <div className='text-zone'>
          <h1>
            <AnimatedLetters 
              letterClass={letterClass}
              strArray={['P','r','o','j','e','c','t','s']}
              idx={8}
            />
          </h1>
          <p className='instruction'> * Click title of each project to see demos</p>
      <div className='flex'>
        <div className='project-list'>
          {
            projects.map(project => (
              <Project key={project._id} project={project} />
            )
            )
          }

  
            {/* <div className='project-0'>
              <h3 className="sub-title"><a target='_blank'   href='https://devtoolsco.netlify.app/' alt='dev-tools-link'>Dev-Tools</a></h3>
              <p className='description'> 
              Dev-Tools is a professional development tool that helps developers manage their time, keep track of their physical health, and organize their day. It offers a variety of features to make development easier, including timers, health checker, kanban board and code journal.
              </p>
              <p className='tech-stack'>React, Axios, Sass, Node.js, Express, Postgres
              </p>
            </div>
        */}
        </div>
         <h3 className='gitHub'>Come check more recent & working projects in <a href="https://github.com/lucky-hw-kim" target="_blank" rel="noreferrer"><span> My Github <FontAwesomeIcon icon={faGithub} /></span></a></h3>
        
      </div>
        </div>
      </div>
      <Loader type="pacman" />
   </>
   )
}

export default Projects